import { useIntersection } from '../../hooks/use-intersection';
import { GrantCard } from '../grants/grant-card';
import { useBookmarks } from './use-bookmark';
import { ListTail } from '../../components/ui/list-tail';

/** 마이 페이지의 「관심 공고」 — 최근 담은 순, 공고 목록과 같은 카드·같은 무한 스크롤. */
export function BookmarkList() {
  const { data, isPending, isError, fetchNextPage, hasNextPage, isFetchingNextPage } = useBookmarks();
  const sentinel = useIntersection(() => void fetchNextPage(), hasNextPage && !isFetchingNextPage);
  const now = new Date();
  if (isPending) return <p className="text-sm text-text-muted">불러오는 중…</p>;
  if (isError) return <p className="text-sm text-text-muted">관심 공고를 불러오지 못했어요.</p>;
  const items = data.pages.flatMap((p) => p.data);
  if (items.length === 0) {
    return <p className="text-sm text-text-muted">아직 담은 공고가 없어요. 공고 상세의 책갈피를 누르면 여기에 모여요.</p>;
  }
  return (
    <div>
      {items.map((g) => (
        <GrantCard key={g.id} grant={g} now={now} />
      ))}
      <div ref={sentinel} aria-hidden className="h-px" />
      <ListTail fetching={isFetchingNextPage} done={!hasNextPage} />
    </div>
  );
}
